import {Table} from "semantic-ui-react";
import React from "react";
import PropTypes from "prop-types";

export function SortableTableHeader(props) {

    const sanitizeDirection = () => {
        return props.direction.toLowerCase().indexOf("asc") ? "ascending" : "descending";
    };

    const isSorted = (columnName) => {
        return props.column === columnName ? sanitizeDirection(props.direction) : null;
    };

    const headerFor = (columnName, width, overrideName, index) =>
        <Table.HeaderCell width={width || 1} className="table-heading"
                          sorted={isSorted(columnName)}
                          key={index}
                          onClick={() => props.onChangeSort(columnName)}>
            {overrideName || columnName}
        </Table.HeaderCell>;

    const Headings = () => props.headings.map((heading, index) => {
        if(heading.column === "empty")
        { return <Table.HeaderCell width={heading.width || 1} key={index}/> }
        else
        { return headerFor(heading.column, heading.width, heading.name, index); }
    });

    return (
        <Table.Header>
            {props.structuredHeading}
            <Table.Row>
                {Headings()}
            </Table.Row>
        </Table.Header>
    );
}

SortableTableHeader.propTypes = {
    direction: PropTypes.string,
    column: PropTypes.string,
    headings: PropTypes.arrayOf(PropTypes.shape({
        column: PropTypes.string.isRequired,
        name: PropTypes.string,
        width: PropTypes.number
    })).isRequired,
    onChangeSort: PropTypes.func,
    structuredHeading: PropTypes.elementType
};
